import axios from 'axios';

const onSuccess = (config: any) => {
    const token = localStorage.getItem('jwt');
    
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

const onError = (error: any) => error;

const configureAxios = () => {
    axios.interceptors.request.use(
        onSuccess,
        onError,
    );
};

export default configureAxios;
